module.exports = __webpack_public_path__ + "static/media/left.1e47e4b1.svg";